import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'
import ReactMarkdown from 'react-markdown'
import './article.sass'

class Markdown extends PureComponent {
  static propTypes = {
    info: PropTypes.string.isRequired
  }

  render() {
    const {info} = this.props
    return (<ReactMarkdown source={info} className="article" escapeHtml={false} />)
  }
}

export default Markdown



// WEBPACK FOOTER //
// ./components/Service_Steps/Info/Markdown/index.jsx